import { Paragraph, TextRun, Table, TableRow, TableCell, WidthType, BorderStyle } from 'docx';

const NONE = { style: BorderStyle.NONE, size: 0, color: 'FFFFFF' };
const NO_BORDERS = { top: NONE, bottom: NONE, left: NONE, right: NONE };
const TABLE_NO_BORDERS = { ...NO_BORDERS, insideH: NONE, insideV: NONE };

const SYSTEM_LABELS = {
  koordinaattori: 'Koordinaattori',
  kuntotutkija: 'Kuntotutkija',
  rakennustekniikka: 'Rakennustekniikka',
  lvia: 'LVIA-järjestelmät',
  sahko: 'Sähköjärjestelmät',
};

export function renderTeamBlockDocx({ data, children, assignments, report }) {
  if (!assignments) return;

  const useMode = report?.type === 'wk3' ? 'ammattinimike' : 'yritys';

  const rows = Object.keys(SYSTEM_LABELS)
    .map(systemKey => {
      const users = assignments[systemKey] || [];
      if (!users.length) return null;
      const names = users.map(u => u.nimi || u.sahkoposti || '—').join('\n');
      const selite = users.map(u => (useMode === 'yritys' ? u.yritys || '—' : u.ammattinimike || '—')).join('\n');
      return { role: SYSTEM_LABELS[systemKey], names, selite };
    })
    .filter(Boolean);

  if (!rows.length) return;

  children.push(
    new Table({
      rows: rows.map(({ role, names, selite }) =>
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph({ children: [new TextRun({ text: role, bold: true, size: 22 })], spacing: { after: 40 } })],
              width: { size: 30, type: WidthType.PERCENTAGE },
              borders: NO_BORDERS,
            }),
            new TableCell({
              children: [new Paragraph({ children: [new TextRun({ text: names, size: 22 })], spacing: { after: 40 } })],
              width: { size: 35, type: WidthType.PERCENTAGE },
              borders: NO_BORDERS,
            }),
            new TableCell({
              children: [new Paragraph({ children: [new TextRun({ text: selite, size: 22 })], spacing: { after: 40 } })],
              width: { size: 35, type: WidthType.PERCENTAGE },
              borders: NO_BORDERS,
            }),
          ],
        })
      ),
      width: { size: 100, type: WidthType.PERCENTAGE },
      borders: TABLE_NO_BORDERS,
    })
  );
}
